export enum TestType {
  ExamFormRLTable = "ExamFormRLTable",
  ExamFormRLTableChoice = "ExamFormRLTableChoice",
  BinaryChoice = "BinaryChoice",
  MultipleChoice = "MultipleChoice",
  MultipleSelect = "MultipleSelect",
  ExamFormDataInput = "ExamFormDataInput",
  YesNoChoice = "YesNoChoice",
  PosNegChoice = "PosNegChoice",
  MultipleSelectDropdown = "MultipleSelectDropdown",
}